import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "swiper/css/bundle";
import './components/assets/css/animate.css';
import './components/assets/css/fontawesome.css';
import './components/assets/css/meanmenu.min.css';
import './components/assets/font/flaticon_flexitype.css';
import './components/assets/sass/style.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import loadingSvg from './components/assets/svg/loading.svg';


import WOW from "wowjs";
import {bootstrapCMS} from "./bootstrapCMS";
import UnderMaintenance from "./components/pages/undermaintenance";
import {getCMSCache} from "./components/utils/cmsStorage";

export const animationCreate = () => {
    if (typeof window !== "undefined") {
        new WOW.WOW({live: false}).init();
    }
};

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

/**
 * ======================================================
 * BOOTSTRAP GUARD (ANTI LOOP, WAJIB ADA)
 * ======================================================
 */
let CMS_BOOTSTRAPPED = false;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <div className="app-loading">
        <div className="app-loading__overlay" />
        <img src={loadingSvg} alt="Loading..." className="app-loading__icon" />
    </div>
);


export async function startApp() {
    if (CMS_BOOTSTRAPPED) return;
    CMS_BOOTSTRAPPED = true;

    const cache = getCMSCache();

    try {
        if (!cache) {
            console.log("[CMS] cache miss → fetching...");
        } else {
            console.log("[CMS] cache hit");
        }

        await delay(1500);
        await bootstrapCMS();

        root.render(
            <React.StrictMode>
                <App/>
            </React.StrictMode>
        );

    } catch (err) {
        console.error("[CMS] bootstrap failed", err);

        root.render(
            <UnderMaintenance/>
        );
    }
}

startApp();

reportWebVitals();
